import request from '@/utils/service'

export function getSubmitList(data) {
  return request({ url: 'submit/list', data })
}

export function updateSubmit(data) {
  return request({ url: 'submit/update', data })
}

export function deleteSubmit(id) {
  return request({ url: `submit/delete?id=${id}` })
}
